import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './i18n';
import './index.css';
import App from './App';
import { store } from './Redux/store';
import { ConfirmProvider } from '@/components/ui/confirm';
import { ThemedToaster } from '@/components/ThemedToaster';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
          <ThemedToaster />
        </ConfirmProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
